import { useEffect, useState } from 'react';

/**
 * Renders the Concrete/Beton department email address (Beton@Kenscho.ca) 
 * that's protected from bot crawlers.
 * The email is obfuscated in the source code and only assembled via JavaScript,
 * which most bots don't execute.
 */
export const ObfuscatedBetonEmail = ({ className = '' }) => {
  const [email, setEmail] = useState('');
  
  useEffect(() => {
    // Obfuscated parts - bots can't easily parse this
    // "Beton" = 66, 101, 116, 111, 110
    const user = String.fromCharCode(66, 101, 116, 111, 110);
    const at = String.fromCharCode(64); // "@"
    const domain = String.fromCharCode(75, 101, 110, 115, 99, 104, 111); // "Kenscho"
    const tld = String.fromCharCode(46, 99, 97); // ".ca"
    
    // Assemble after a tiny delay to further confuse crawlers
    const timer = setTimeout(() => {
      setEmail(`${user}${at}${domain}${tld}`);
    }, 10);
    
    return () => clearTimeout(timer);
  }, []);

  const handleClick = () => {
    // Create the mailto: link dynamically
    const user = String.fromCharCode(66, 101, 116, 111, 110);
    const at = String.fromCharCode(64);
    const domain = String.fromCharCode(75, 101, 110, 115, 99, 104, 111); // "Kenscho"
    const tld = String.fromCharCode(46, 99, 97);
    window.location.href = `mailto:${user}${at}${domain}${tld}`;
  };

  return (
    <button 
      onClick={handleClick}
      className={`hover:text-primary transition-colors cursor-pointer text-left ${className}`}
      aria-label="Email concrete department"
      data-testid="beton-email-address"
    >
      {email || '•••••@•••••••.••'}
    </button>
  );
};
